import React, { useState } from 'react'

export const RefreshSideListContext = React.createContext()

export const withRefreshSideList = Component => props => {
	const [refreshSideList, setRefreshSideList] = useState()
	const [refreshItemData, setRefreshItemData] = useState(false)
	const value = {
		refreshSideList,
		setRefreshSideList: setRefreshSideList,
		refreshItemData,
		setRefreshItemData: setRefreshItemData
	}
	return(
		<RefreshSideListContext.Provider value={value}>
			<Component {...props}/>
		</RefreshSideListContext.Provider>
	)
}
